import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { UserRoleName } from '../identity/types/UserProfile';

export type IConversationStatistics = {
  case_id: number;
  case_type: string;
  case_video_conference_date: string | null;
  conversation_sid: string;
  unread_message_count: number;
  archived: boolean | null;
  patient_id: number | null;
  patient_full_name: string | null;
};

export const listConversationStatistics = async (
  filter?: 'active' | 'archived',
  userRole?: string,
): Promise<IConversationStatistics[]> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  if (prefix) {
    const { data } = await client.get<IConversationStatistics[]>(`${prefix}/conversations/statistics`, {
      params: filter ? { filter } : undefined,
    });
    return data;
  }
  try {
    const { data } = await client.get<IConversationStatistics[]>(`/conversations/statistics`, {
      params: filter ? { filter } : undefined,
    });
    return data;
  } catch (error: any) {
    if ((!userRole || userRole === UserRoleName.Collector) && error?.response?.status === 403) {
      const collectorPrefix = getStaffScopedApiPrefix(UserRoleName.Collector);
      const { data } = await client.get<IConversationStatistics[]>(`${collectorPrefix}/conversations/statistics`, {
        params: filter ? { filter } : undefined,
      });
      return data;
    }
    throw error;
  }
};
